import {applyMiddleware, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducer, {reducerPreloadedState} from './reducer';
import {watchAnalyticsSaga} from './sagas/analytics.saga';
import {watchModalSaga} from './sagas/modal.saga';
import {watchPresentationSaga} from './sagas/presentation.saga';
import {watchRunFileSaga} from './sagas/runfile.saga';
import {watchRoomRunFileSaga} from './sagas/roomRunFile.saga';
import {watchAuthSaga} from './sagas/auth.saga';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(reducer, reducerPreloadedState, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(watchPresentationSaga);
sagaMiddleware.run(watchRunFileSaga);
sagaMiddleware.run(watchAnalyticsSaga);
sagaMiddleware.run(watchModalSaga);
sagaMiddleware.run(watchRoomRunFileSaga);
sagaMiddleware.run(watchAuthSaga);
